import script from "./Minus.vue?vue&type=script&setup=true&lang=js"
export * from "./Minus.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__